export class ClaudeEnterpriseSourceAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "complianceAccessKey",
            "baseName": "complianceAccessKey",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ClaudeEnterpriseSourceAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
